export const tipo_tratado_model = {
  Codigo: null,
  Descripcion: '',
  Activo: true,
};

export const tipo_tratado_filters = {
  Descripcion: '',
  Activo: true,
};
